import '../../assets/styles/header.css';

import { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoBell } from "react-icons/go";
import { TfiMenuAlt } from "react-icons/tfi";
import { RiLogoutCircleLine } from "react-icons/ri";
import { AuthContext } from '../../features/auth/AuthProvider';
import { useViewProfile } from '../../hooks/auth/profile';
import adminAvatar from '../../assets/images/admin.png';
import { userPermssionsStore } from '../../store/permissions.store';



export default function Header({ onToggleSidebar }) {


   const canView = userPermssionsStore((state) => state.canView);
    const canViewSettings = canView('Settings');
    


    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const { logout } = useContext(AuthContext);
    const { data: profile } = useViewProfile();

    const getPageTitle = (pathname) => {
        switch (pathname) {
            case '/':
                return 'Dashboard';
            case '/login':
                return 'Login';
            case '/categories':
                return 'Categories';
            default:
                // Capitalize and prettify the last segment
                const last = pathname.split('/').filter(Boolean).pop();
                return last ? last.charAt(0).toUpperCase() + last.slice(1) : '';
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };

        if (activeDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [activeDropdown]);

    

    return(
        <>
        <header>
            <nav className="header_nav">
                <div className="header_container">
                    <div className='menuSearch'>
                        <TfiMenuAlt onClick={onToggleSidebar} className='menubar'/>
                        <span className="page-title">{getPageTitle(location.pathname)}</span>
                    </div>
                    <div className="header_title" ref={dropdownRef}>
                        <GoBell
                            className='bell'
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate('/notification')}
                            aria-label="Notifications"
                        />
                        <div className="header-profile-area">
                            <div className="header-avatar-wrap" onClick={() => setActiveDropdown(activeDropdown ? null : 'profile')}>
                                <img
                                    src={profile?.user?.avatarUrl || adminAvatar}
                                    alt="avatar"
                                    className="header-avatar"
                                    style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', cursor: 'pointer', border: '2px solid #004996' }}
                                />
                                <span className="header-avatar-name" style={{ marginLeft: 8, fontWeight: 500 }}>
                                    {profile?.user?.name || 'Admin'}
                                </span>
                            </div>
                            {activeDropdown === 'profile' && (
                                <div className="header-profile-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 10px)', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', borderRadius: 8, minWidth: 160, zIndex: 10 }}>
                                    {/* <button className="header-profile-dropdown-item" style={{ width: '100%', padding: '10px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }} onClick={() => { setActiveDropdown(null); navigate('/profile'); }}>Profile</button> */}
                                    {canViewSettings && (
                                        <button className="header-profile-dropdown-item" style={{ width: '100%', padding: '10px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }} onClick={() => { setActiveDropdown(null); navigate('/settings'); }}>Settings</button>
                                    )}
                                    <button className="header-profile-dropdown-item" style={{ width: '100%', padding: '10px 16px', background: 'none', border: 'none', textAlign: 'left', color: '#d32f2f', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }} onClick={() => { setActiveDropdown(null); logout(); navigate('/login'); }}><RiLogoutCircleLine style={{ fontSize: 18 }} />Logout</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </header>
        </>
    )
};

